import { memo } from 'react';

import { PopularSmartTags, type PopularSmartTagsProps } from '~/components/Filters/SmartTagsFilter/PopularSmartTags';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useGetPrivateSmartTagList } from '~/swr-hooks/filters/useGetPrivateSmartTagList';

export type PrivatePopularSmartTagsProps = Pick<PopularSmartTagsProps, 'className' | 'onSmartTagClick'>;

export const PrivatePopularSmartTags = memo(({ className, onSmartTagClick }: PrivatePopularSmartTagsProps) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { data: popularSmartTags } = useGetPrivateSmartTagList({
    sortField: 'count',
    sortDirection: 'desc',
    limit: 10,
    workspaceId: currentWorkspace?.id,
  });

  if (!popularSmartTags) {
    return null;
  }

  return <PopularSmartTags className={className} smartTags={popularSmartTags} onSmartTagClick={onSmartTagClick} />;
});

PrivatePopularSmartTags.displayName = 'PrivatePopularSmartTags';
